import { ShowWithImages } from 'types/Show'

import { ShowCardAdmin } from './components/showCard'
import { Container } from './showList.style'

interface Props {
    data: ShowWithImages[]
    onEdit: (data: any) => void
    onDelete: (id: any) => void
}

export const ShowListAdmin = ({ data, onEdit, onDelete }: Props) => {
    return (
        <Container>
            {data.map((current) => (
                <ShowCardAdmin data={current} key={current.show_id} onEdit={onEdit} onDelete={onDelete} />
            ))}
        </Container>
    )
}
